import { render, staticRenderFns } from "./document-history.vue?vue&type=template&id=fe2a319e&scoped=true&"
import script from "./document-history.vue?vue&type=script&lang=js&"
export * from "./document-history.vue?vue&type=script&lang=js&"
import style0 from "./document-history.vue?vue&type=style&index=0&id=fe2a319e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a319e",
  null
  
)

component.options.__file = "document-history.vue"
export default component.exports